import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import MemoryForm from './MemoryForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/memoryActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const MemoryEdit = props => {
    const { memories, loading, classes, onFetchMemoryInit, activeCustomer, translations, permissions } = props;
    const [data, setData] = useState(true);
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ComponentID'] = memories.ComponentID;
        data['ComponentType'] = 'memory';
        data['ProductID'] = searchParams.productID;

        let result = await props.onEditMemory({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchMemory({ ActiveCustomerID: activeCustomer, ComponentID: parseURL(window.location.href).ComponentID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchMemoryInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ComponentType: "memory", Vendor: memories.Vendor || "",
        ComponentModel: memories.ComponentModel || '',
        SerialNumber: memories.SerialNumber || '',
        Width: memories && memories.MemoryComponents && memories.MemoryComponents.length > 0 ? memories.MemoryComponents[0].Width : 0 || 0,
        Size: memories && memories.MemoryComponents && memories.MemoryComponents.length > 0 ? memories.MemoryComponents[0].Size : 0,
        Slot: memories && memories.MemoryComponents && memories.MemoryComponents.length > 0 ? memories.MemoryComponents[0].Slot : 0,
        RAMType: memories && memories.MemoryComponents && memories.MemoryComponents.length > 0 ? memories.MemoryComponents[0].RAMType : '',
        Description: memories.Description || ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            Width: Yup.number().required("Required"),
            Size: Yup.number().required("Required"),
            RAMType: Yup.string().required("Required"),
        },
        FormTitle: translations['edit_memory'] || "Edit memory ",
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <MemoryForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                ></MemoryForm>
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        memories: state.product.memories.loaded ? state.product.memories.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchMemoryInit: memories => dispatch(actions.loadMemoryInit(memories)),
        onFetchMemory: memories => dispatch(actions.loadMemory(memories)),
        onEditMemory: memories => dispatch(actions.editMemory(memories)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MemoryEdit));
